var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoGrayRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16143",
    "data-name": "Rectangle 16143",
    width: 24,
    height: 24,
    transform: "translate(0 0)",
    fill: "#bababa"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15427",
    "data-name": "Group 15427",
    transform: "translate(0 0.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15426",
    "data-name": "Group 15426",
    transform: "translate(0 -0.343)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41213",
    "data-name": "Path 41213",
    d: "M11.739,23.452a11.725,11.725,0,1,1,11.7-11.739,11.725,11.725,0,0,1-11.7,11.739m-.485-13.075,0-.04c-.463.059-.931.1-1.387.189-.147.03-.265.208-.4.319.131.109.247.274.4.317.775.219.811.277.664,1.1q-.308,1.725-.586,3.455a1.325,1.325,0,0,0,.9,1.511,2.831,2.831,0,0,0,2.876-.6c.132-.128.152-.372.224-.563-.186.02-.373.036-.558.062-.281.039-.684.217-.812.1-.177-.165-.152-.552-.2-.846A.558.558,0,0,1,12.4,15.2c.2-1.087.408-2.173.6-3.262.185-1.035-.173-1.483-1.233-1.556-.171-.012-.343,0-.514,0m.547-1.2a1.533,1.533,0,1,0-1.5-1.594,1.554,1.554,0,0,0,1.5,1.594",
    transform: "translate(0 0.548)",
    fill: "#bababa"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGrayRound);
export default __webpack_public_path__ + "static/media/info-gray-round.a42e07043e9f7cbe2ef386d7f6c04e78.svg";
export { ForwardRef as ReactComponent };